if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    // CLOSE MAIN NAV MOBILE
	document.querySelectorAll('.close-menu').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.remove('active');
			});
		}
	});

    // OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-show_nav_m]').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.add('active');
			});
		}
	});

    document.addEventListener("DOMContentLoaded", function() {
        var boton1 = document.getElementById("button-0");
        var boton2 = document.getElementById("button-1");
        var contenedores = document.querySelectorAll(".double-cards__item");

        contenedores[0].classList.add("active");
        if (boton1){
            boton1.classList.add("active");
            
            boton1.addEventListener("click", function() {
                contenedores[0].classList.add("active");
                contenedores[1].classList.remove("active");
                this.classList.add("active");
                boton2.classList.remove("active");
            });
        }
        
        if (boton2){
            boton2.addEventListener("click", function() {
                contenedores[1].classList.add("active");
                contenedores[0].classList.remove("active");
                this.classList.add("active");
                boton1.classList.remove("active");
            });
        }
    });
    

})();